import { useCallback } from 'react';
import {
  trackAnalytics,
  getDistinctWordsCount,
  getTextLength,
} from 'common/components/CopyMagic/shared/dataHelpers';
import { useConfigContext } from 'common/components/CopyMagic/contexts';

import { PromptFormValuesType } from 'common/components/CopyMagic/CopyMagic.types';
import { ContentAssistantResultType } from 'common/components/CopyMagic/generators/ContentAssistant/ContentAssistant.types';

type CallbackInput = {
  isSuccess: boolean;
  isModerated: boolean;
  isGeneratedAgain: boolean;
  result?: ContentAssistantResultType;
  promptValues: PromptFormValuesType;
};

/*
useTrackPromptResponse trackingCallback
  Because of the invocation location of this tracking callback,
  a race condition can occur with `result` being set in the ResultContext,
  therefore we pass `result` as an arg instead.
*/

const useTrackPromptResponse = () => {
  const { productEvents } = useConfigContext();

  const trackCallback = useCallback(
    ({ isSuccess, isModerated, isGeneratedAgain, result, promptValues }: CallbackInput) => {
      const trackProductAnalytics = trackAnalytics(productEvents);

      trackProductAnalytics('Generated', {
        'Input': promptValues.topic,
        'Is Success': isSuccess,
        'Content Moderated': isModerated,
        'Generated Again': isGeneratedAgain,
        'Content ID': result?.id,
        'Text Length': getTextLength(result),
        'Word Count': getDistinctWordsCount(result),
      });
    },
    [productEvents],
  );

  return trackCallback;
};

export default useTrackPromptResponse;
